import { useEffect, useRef, useState } from 'react';
import { RoutingRuleType } from 'src/graphql';

const defaultNameRegexPattern =
  /^Untitled Rule Name \d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/;

const duplicatedNameRegexPattern = /^Duplicated.*/;

interface Parameters {
  rule: RoutingRuleType;
}

export const useRoutingRuleName = ({ rule }: Parameters) => {
  const [originalRuleName, setOriginalRuleName] = useState(rule.name);
  const [hasUpdatedName, setHasUpdatedName] = useState(false);
  const initialRuleName = useRef('');

  const isNewName =
    !defaultNameRegexPattern.test(rule.name) &&
    !duplicatedNameRegexPattern.test(rule.name);

  useEffect(() => {
    if (!initialRuleName.current && rule.name) {
      initialRuleName.current = rule.name;
    }

    if (
      !defaultNameRegexPattern.test(initialRuleName.current) &&
      !duplicatedNameRegexPattern.test(initialRuleName.current)
    ) {
      setHasUpdatedName(true);
    }
  }, [rule.name]);

  return {
    hasUpdatedName,
    setHasUpdatedName,
    isNewName,
    originalRuleName,
    setOriginalRuleName,
  };
};
